import {Component} from '@angular/core';
import {ActivatedRoute} from "@angular/router";

@Component({
    selector: 'app-not-found-error',
    templateUrl: './not-found-error.component.html',
    styleUrls: ['./not-found-error.component.scss'],
})
export class NotFoundErrorComponent {
    constructor(private route: ActivatedRoute) {
    }

    ngOnInit() {
        const url = this.route.snapshot.paramMap.get('url');
    }
}
